import React from 'react';

const Errors = ({ errors }) => {
  if (!errors || !Array.isArray(errors)) return null;

  return (
    <div>
      {errors.map((error, index) => (
        <div key={index} className="text-red-500 text-xs">
          {error.message}
        </div>
      ))}
    </div>
  );
};

export default Errors;
